import React, { createContext, useContext, useState } from 'react';

const NavbarContext = createContext();

export const useNavbar = () => useContext(NavbarContext);

export const NavbarProvider = ({ children }) => {
    const [isNavbarVisible, setIsNavbarVisible] = useState(true);

    const showNavbar = () => setIsNavbarVisible(true);
    const hideNavbar = () => setIsNavbarVisible(false);

    return (
        <NavbarContext.Provider value={{ isNavbarVisible, showNavbar, hideNavbar }}>
            {children}
        </NavbarContext.Provider>
    );
};
